<div class="wk-insert-web-email-address-link">
  <header>
    <h3 class="mb-0" mat-dialog-title>
      {{ 'ADF_INSERT_LINK.WEB_EMAIL_ADDRESS_TITLE' | translate }}
    </h3>
  </header>
  <section class="section">
    <form [formGroup]="form">
      <div>
        <wk-input
          label="{{
            'ADF_INSERT_LINK.WEB_EMAIL_ADDRESS_TEXT_DISPLAY' | translate
          }}"
        >
          <input
            class="wk-field-input insert-link-input"
            autocomplete="off"
            type="text"
            id="linkText"
            formControlName="linkText"
          />
        </wk-input>

        <wk-input
          label="{{ 'ADF_INSERT_LINK.WEB_EMAIL_ADDRESS_LINK' | translate }}"
        >
          <input
            class="wk-field-input insert-link-input"
            autocomplete="off"
            type="text"
            id="linkAddress"
            formControlName="linkAddress"
          />
        </wk-input>
      </div>
    </form>
  </section>
</div>

<div class="action-buttons">
  <button class="wk-button wk-button-text" (click)="closeDialog()">
    {{ 'ADF_INSERT_LINK.CANCEL_BUTTON' | translate }}
  </button>
  <button
    class="wk-button"
    type="submit"
    [disabled]="!form.valid"
    (click)="insertLink()"
  >
    {{ 'ADF_INSERT_LINK.WEB_EMAIL_ADDRESS_TITLE' | translate }}
  </button>
</div>
